$shm_hitalama_mbutton $mol_check
	sub /
		<= Front $mol_view sub / 
			<= Img $mol_image
				uri \shm/hitalama/mbutton/img/mbutton.svg
	style *
		^
		^ checked_style *
